import { render, staticRenderFns } from "./FooTer.vue?vue&type=template&id=55d57a58&scoped=true"
var script = {}
import style0 from "./FooTer.vue?vue&type=style&index=0&id=55d57a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d57a58",
  null
  
)

export default component.exports